import { SHOP_TYPE_LABELS, type ShopType, type ShopTypeLabels } from "@autorepair/contracts";
import { useAuth } from "./useAuth";

/**
 * What kind of business the CURRENT tenant is — see docs/SHOP_TYPES_PLAN.md
 * and SHOP_TYPE_LABELS' own doc comment. A pure read, present from session
 * creation. Defaults to "auto_repair" while the initial session check is
 * still in flight or for a signed-out visitor (no session/tenant to read
 * a shop type off at all).
 */
export function useShopType(): ShopType {
  const { session } = useAuth();
  return session?.shopType ?? "auto_repair";
}

/** What PART/LABOR/SUBLET are called for the current tenant — the one
 * thing every work order, predefined-items, and invoice/estimate screen
 * should read instead of hardcoding "Part"/"Labor"/"Sublet" text. */
export function useShopTypeLabels(): ShopTypeLabels {
  return SHOP_TYPE_LABELS[useShopType()];
}
